import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import PropTypes from 'prop-types';

import appSelectors from '@/redux/app/appSelectors';
import userSelectors from '@/redux/user/userSelectors';

import useMatchMedia from '@/hooks/useMatchMedia';

import copyImg from '@/images/copy-gray.svg';
import ArrowIcon from '@/images/nav_icons/chevron-right.svg?react';
import DotsIcon from '@/images/dots.svg?react';

import MenuProfile from '../menuProfile';

import s from './btnProfile.module.css';

function BtnProfile({ hideMenu }) {
  const i18n = useSelector(appSelectors.translation);
  const user = useSelector(userSelectors.user);

  const [displayProfile, setDisplayProfile] = useState(false);
  const toggleProfile = () => setDisplayProfile(!displayProfile);

  const copyIdToClipboard = async e => {
    e.stopPropagation();

    if (!user?.login) return;

    try {
      navigator.clipboard.writeText(user.login);
      Notify.success('UID copied to clipboard!');
    } catch (err) {
      console.error(err);
    }
  };

  const { isMobile } = useMatchMedia();

  return (
    <div className={s.profile_wrapper}>
      <div className={s.user} onClick={toggleProfile}>
        <div className={s.avatar}>
          {user?.avatarUrl ? (
            <img src={user.avatarUrl} alt="profile" />
          ) : (
            <span>{user?.gravatar}</span>
          )}
        </div>

        <div className={s.name_id_wrapper}>
          <p className={s.name}>
            {user?.firstName} {user?.lastName}
          </p>
          <button type="button" onClick={copyIdToClipboard} className={s.id}>
            {i18n['ID'] || 'UID'}: {user?.login}
            <img src={copyImg} alt="copy" />
          </button>
        </div>

        <div className={s.arrow} data-open={displayProfile}>
          {isMobile ? <ArrowIcon /> : <DotsIcon />}
        </div>
      </div>

      {displayProfile && (
        <MenuProfile hideProfile={toggleProfile} hideMenu={hideMenu} />
      )}
    </div>
  );
}

export default BtnProfile;

BtnProfile.propTypes = {
  hideMenu: PropTypes.func,
};
